// ink-component
import React, { RefObject } from 'react';

import Anchor, { AnchorProps } from '../../Anchor/Anchor';

export interface BreadcrumbAnchorProps extends AnchorProps {
  /** React ref object to be forwarded to the internal node */
  externalRef?: RefObject<HTMLAnchorElement>;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** Unique name for analytics purposes. By default, components are not tracked, unless this is set */
  'data-track-name'?: string;
  /** Custom payload to be sent to analytics provider */
  'data-track-payload'?: any;
  /** List of tracked events in the analytics integration */
  'data-track-events'?: string[];
}

/**
 * @purpose An anchor type inside a Breadcrumb
 * @group Breadcrumb
 * @categories navigation
 * @HTMLType HTMLAnchorElement
 */
function BreadcrumbAnchor(props: BreadcrumbAnchorProps) {
  const { className, style, ...otherProps } = props;
  return <Anchor {...otherProps} />;
}

BreadcrumbAnchor.defaultProps = {
  'data-track-events': ['click'],
};

BreadcrumbAnchor.displayName = 'Breadcrumb.Anchor';

export default BreadcrumbAnchor;
